module.exports = __webpack_public_path__ + "img/role03.7bc83f75.png";